import { Injectable } from '@angular/core';
import { NativeStorage } from '@ionic-native/native-storage/ngx';

@Injectable({
  providedIn: 'root'
})
export class NativeStorageService {

  constructor(private _storage:NativeStorage) { }

  storeData(refrence:string, value:any):Promise<any>{
    return this._storage.setItem(refrence, value);
  }
  retriveData(refrence:string):Promise<any>{
    return this._storage.getItem(refrence);
  }
  removeDate(refrence:string):Promise<any>{
    return this._storage.remove(refrence);
  }

}
